<template>
    <div class="white">
        <actionbar v-bind:select='true' v-bind:modify='true'
        v-on:select='select'
        v-on:modify='modify'
        >
        </actionbar>
        <tablepage ref="tableref" id="tableref"
         v-on:created='tableCreated'
         v-on:currentPage='currentPage'
         v-on:currentRow='currentRow'
         :cols='cols'
         :items='items'
         :total='total'
         :perpage='count'
        ></tablepage>
         <b-modal ref="modallg" size="lg" v-bind:title="title" hide-footer class="ksmodal"
         header-bg-variant="success"
         body-text-variant="dark">
                  <b-tabs>
                        <b-tab :title="$t('水压告警')" active>
                            <hr>
                            <alarmAction  :car="true" :alarm="true" :value="modalData.shuiya"  :filter="true"></alarmAction>
                        </b-tab>
                        <b-tab :title="$t('异常出水')">
                            <alarmAction  :car="true" :alarm="true" :value="modalData.chushui"  :filter="true"></alarmAction>
                            <hr>
                        </b-tab>
                        <b-tab :title="$t('封盖开启')">
                            <alarmAction  :car="true" :alarm="true" :value="modalData.fenggai"  :filter="true"></alarmAction>
                            <hr>
                        </b-tab>
                        <b-tab :title="$t('震动告警')">
                            <alarmAction  :car="true" :alarm="true" :value="modalData.zhengdong"  :filter="true"></alarmAction>
                            <hr>
                        </b-tab>
                        <b-tab :title="$t('倾斜告警')">
                            <alarmAction  :car="true" :alarm="true" :value="modalData.qingxie"></alarmAction>
                            <hr>
                        </b-tab>
                  </b-tabs>
         </b-modal>
    </div>
</template>

<script>
import actionbar from '@/components/actionbar'
import tablepage from '@/components/tablepage'
import modify from '@/components/modify'
import alarmAction from '@/components/alarmAction'
import {Link} from '@/assets/utils/datef'
export default {
    components:{actionbar,tablepage,modify,alarmAction},
    data:function(){
        return{
            radio:0,
            title:this.$t("修改"),
            modalData:this.resetData(),
            loading:{},
            cols:[
                {name:this.$t("设备名"),value:"DeviceName"},
                {name:this.$t("设备类型"),value:"TypeName",subvalue:"DeviceType"},
                {name:this.$t("设备型号"),value:"ModelNumber",subvalue:"DeviceType"},
                {name:this.$t("水压告警"),value:"State",subvalue:"shuiya"},
                {name:this.$t("异常出水"),value:"State",subvalue:"chushui"},
                {name:this.$t("封盖开启"),value:"State",subvalue:"fenggai"},
                {name:this.$t("震动告警"),value:"State",subvalue:"zhengdong"},
                {name:this.$t("倾斜告警"),value:"State",subvalue:"qingxie"},
            ],
            items:[],
            total:0,
            count:2000,
            index:0,
            sid:"",
            current:null,
            link:Link().filter(function(x){return x.state==1}),
        }
    },
    methods:{
        select(noloading,index){
            if(!noloading){
                if(!index){
                    this.index=0;
                }
                this.loading=this.$loading({fullScreen:true});
            }
             new Promise((res,rej)=>{
                let obj={
                    Index:this.index,
                    Count:this.count
                }
                this.$ksajax.ksPostPromise("/api/device/GetFireHydrants",obj,true).then((data)=>{
                    this.items=[];
                    data.Items.forEach(x => {
                            x.shuiya={
                                LinkageActions:[]};
                            x.chushui={
                                LinkageActions:[]};
                            x.fenggai={
                                LinkageActions:[]};
                            x.zhengdong={
                                LinkageActions:[]};
                            x.qingxie={
                                LinkageActions:[]};
                        this.items.push(x);
                    });
                    res();
                }).catch(err=>{
                    rej(err);
                })
             }).then(()=>{
                 return new Promise((res,rej)=>{
                     let obj={
                    Index:this.index,
                    Count:this.count,
                    DevCtgSid:"012"
                    }
                    this.$ksajax.ksPostPromise("/api/device/GetSensorLinkages",obj,true).then((data)=>{
                        this.items.forEach((x)=>{
                            data.Items.forEach((y)=>{
                                if(y.LinkageActions){
                                    y.LinkageActions.forEach((l)=>{
                                        l.link=this.link.find(o=>o.value==l.LinkageType);
                                        l.guid=this.guid();
                                    })
                                }
                                if(y.DeviceSid==x.Sid){
                                    y.State=y.IsEnabled==0?"关闭":"开启"
                                    if(y.DataKind==50){
                                        x.shuiya=y;
                                    }
                                    if(y.DataKind==51){
                                        x.chushui=y;
                                    }
                                    if(y.DataKind==52){
                                        x.fenggai=y;
                                    }
                                    if(y.DataKind==54){
                                        x.zhengdong=y;
                                    }
                                    if(y.DataKind==55){
                                        x.qingxie=y;
                                    }
                                }
                            })
                        });
                        res();
                    }).catch(err=>{
                        rej(err);
                    })
                 })
             }).then(()=>{
                 if(this.loading.close){
                     this.loading.close();
                 }
             }).catch((err)=>{
                 this.$throw(err);
                 if(this.loading.close){
                     this.loading.close();
                 }
             })
        },
        guid(){
            var guid = "";
            for (var i = 1; i <= 32; i++){
            var n = Math.floor(Math.random()*16.0).toString(16);
            guid +=   n;
            if((i==8)||(i==12)||(i==16)||(i==20))
                guid += "-";
            }
            return guid; 
                },
        del(){
            if(this.current==null)
            {
                throw this.$t("选择一条数据");
            }
            this.sid=this.current.Sid;
            this.$refs.ksmodel.show();
        },
        modify(){
            if(this.current==null)
            {
                throw this.$t("选择一条数据");
            }
                this.modalData.shuiya={
                    "Sid": this.current.shuiya?this.current.shuiya.Sid:null,
                    "LinkageName": "水压告警",
                    "IsEnabled":  this.current.shuiya?this.current.shuiya.IsEnabled:false,
                    "DeviceSid": this.current.Sid,
                    "DataKind": 50,
                    "ThresholdValue": 0.1,
                    "CompareSymbol": this.current.shuiya?this.current.shuiya.CompareSymbol:-1,
                    "LinkageActions":this.current.shuiya?this.current.shuiya.LinkageActions:[],
                    "IsContrary":this.current.shuiya?this.current.shuiya.IsContrary:false,
                }
                this.modalData.chushui={
                    "Sid": this.current.chushui?this.current.chushui.Sid:null,
                    "LinkageName": "异常出水",
                    "IsEnabled":  this.current.chushui?this.current.chushui.IsEnabled:false,
                    "DeviceSid": this.current.Sid,
                    "DataKind": 51,
                    "ThresholdValue": 1,
                    "CompareSymbol": this.current.chushui?this.current.chushui.CompareSymbol:0,
                    "LinkageActions":this.current.chushui?this.current.chushui.LinkageActions:[],
                    "IsContrary":this.current.chushui?this.current.chushui.IsContrary:false,
                }
                
                this.modalData.fenggai={
                    "Sid": this.current.fenggai?this.current.fenggai.Sid:null,
                    "LinkageName": "封盖开启",
                    "IsEnabled":  this.current.fenggai?this.current.fenggai.IsEnabled:false,
                    "DeviceSid": this.current.Sid,
                    "DataKind": 52,
                    "ThresholdValue": 1,
                    "CompareSymbol": this.current.fenggai?this.current.fenggai.CompareSymbol:0,
                    "LinkageActions":this.current.fenggai?this.current.fenggai.LinkageActions:[],
                    "IsContrary":this.current.fenggai?this.current.fenggai.IsContrary:false,
                }
                
                this.modalData.zhengdong={
                    "Sid": this.current.zhengdong?this.current.zhengdong.Sid:null,
                    "LinkageName": "震动告警",
                    "IsEnabled":  this.current.zhengdong?this.current.zhengdong.IsEnabled:false,
                    "DeviceSid": this.current.Sid,
                    "DataKind": 54,
                    "ThresholdValue": 1,
                    "CompareSymbol": this.current.zhengdong?this.current.zhengdong.CompareSymbol:0,
                    "LinkageActions":this.current.zhengdong?this.current.zhengdong.LinkageActions:[],
                    "IsContrary":this.current.zhengdong?this.current.zhengdong.IsContrary:false,
                }
                
                this.modalData.qingxie={
                    "Sid": this.current.qingxie?this.current.qingxie.Sid:null,
                    "LinkageName": "倾斜告警",
                    "IsEnabled":  this.current.qingxie?this.current.qingxie.IsEnabled:false,
                    "DeviceSid": this.current.Sid,
                    "DataKind": 55,
                    "ThresholdValue": 1,
                    "CompareSymbol": this.current.qingxie?this.current.qingxie.CompareSymbol:0,
                    "LinkageActions":this.current.qingxie?this.current.qingxie.LinkageActions:[],
                    "IsContrary":this.current.qingxie?this.current.qingxie.IsContrary:false,
                }
            this.$refs.modallg.show();
        },
        tableCreated(){},
        currentPage(){
        },
        currentRow(val){
            this.current=val;
        },
        resetData(){
           return   {
             shuiya:{LinkageActions:[]},
              chushui:{LinkageActions:[]},
              fenggai:{LinkageActions:[]},
              zhengdong:{LinkageActions:[]},
              qingxie:{LinkageActions:[]},
           }
        }
        },
    mounted:function(){
        this.select();
    }
}
</script>
